import validation from "vee-validate/dist/locale/nl.json";
export const vee_validate = {
    fields: {
        lastname: "naam",
        firstname: "voornaam",
        email: "e-mail",
        gender: "vriendelijk",
        optin_terms_conditions:"voorwaarden",
        optin_privacy:"privacybepalingen",
        street:"adres",
        street_number:"n°",
        street_box_number:"postbus",
        zip_code:"postcode",
        city:"plaats",
        iban:"iban",
        phone:"gsm-nummer",
    },
    validation: {
        ...validation.messages,
        minmax: 'NL The {_field_} field must have at least {min} characters and {max} characters at most',
        is:'{_field_} is niet geldig.',
        name:'{_field_} is niet geldig.',
    }
}
